// extracted by mini-css-extract-plugin
export default {"img-outer":"style_img-outer__4QLY5__WHx6O","img":"style_img__PSExq__WHx6O","loading":"style_loading__WCOwA__WHx6O","error":"style_error__+ECgZ__WHx6O"};